/**
Service for fetching a map legend for a given geo model layer.

Return a list of layers i JSON format with color, long name, name and sort oder.
*/

import { GeoWebServiceClient } from './GeoWebServiceClient'

/**
 * Object type describing the properties of the available layers.
 */
export interface MapLegendObject {
  Color: string
  Name: string
  LongName: string
  SortOrder: string
}

/**
 * Web service for fetching a map legend for a given geo model layer.
 * The following parameter is required: 'ModelId' ( @see setModelId ).
 */
export class MapLegend extends GeoWebServiceClient {
  static get URL (): string { return 'https://data.geo.dk/api/v3/maplegend' }

  /**
   * Constructor.
   * @param token The Geo auth token.
   */
  constructor (token: string) {
    super(MapLegend.URL, token, {})
  }

  /**
   * [Required*] Setter for the model id.
   * @param modelId The model id.
   */
  setModelId (modelId: string): void {
    this.addParam('ModelId', modelId.toString())
  }

  /**
   * Validates that required params are given.
   */
  private validateParams (): void {
    if (!(this.hasParam('ModelId'))) {
      throw new Error('Parameter mismatch: The modelId param must be set.')
    }
  }

  /**
   * Calls the web service.
   * @returns A promise bearing the map legend.
   */
  async fetchMapLegend (): Promise<MapLegendObject[]> {
    this.validateParams()
    const response: Response = await fetch(this.url(), { headers: { Authorization: `Bearer ${this.token}` } })
    if (!response.ok) {
      throw new Error('Got invalid HTTP response.')
    }
    return await response.json()
  }
}
